<script>
export default {}
</script>
<template>
  <icon-base name="cheveron-down">
    <path d="M10.707 7.05L10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z" />
  </icon-base>
</template>   